import type { ResolvedMonospaceSingleRelationField } from '#layers/data-model/types/schema/resolved-schema';
import { getRelationFieldPresentationDefaults } from '#layers/data-model/constants/fields';
import { WorkspaceCollectionIds } from '#layers/data-model/constants/schema/collection-ids';
import { resolveFieldInputPresentation } from '#layers/data-model/utils/fields/presentation';
import { isM2M, isRelationToMonospaceFiles } from '#layers/data-model/utils/relation';

export function getSingleRelationFieldInputBlockOptions(field: ResolvedMonospaceSingleRelationField): {
	block: string;
	props?: Record<string, any>;
} {
	const defaults = getRelationFieldPresentationDefaults(field).input;
	return resolveFieldInputPresentation(defaults, field.meta);
}

export function isFileThumbnailField(field: ResolvedMonospaceSingleRelationField) {
	return field.apiName === '$thumbnail' && field.collectionId === WorkspaceCollectionIds.MonospaceFile;
}

export function isToOneFileRelation(field: ResolvedMonospaceSingleRelationField) {
	return !field.isList && !isM2M(field) && isRelationToMonospaceFiles(field);
}
